import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderShippingMethodModel } from '../models/order-shipping-method.model';

export class OrderShippingMethodsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/shipping-methods';

  /**
   * @param {String|Number} orderId
   * @param {Number|null} shippingMethodId
   * @return {String}
   * @protected
   */
  static buildOrderShippingMethodUrl(orderId, shippingMethodId = null) {
    return this.buildUrl(shippingMethodId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} shippingMethodId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderShippingMethodModel>>}
   * @public
   */
  static async get(orderId, shippingMethodId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderShippingMethodUrl(orderId, shippingMethodId), {
      ...config,
      dataModel: OrderShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderShippingMethodModel>>}
   * @public
   */
  static getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderShippingMethodUrl(orderId), {
      ...config,
      dataModel: OrderShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} shippingMethodId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderShippingMethodModel>>}
   * @public
   */
  static async patch(orderId, shippingMethodId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderShippingMethodUrl(orderId, shippingMethodId), data, {
      ...config,
      dataModel: OrderShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
